import axios from "axios";
import { getRequest, postRequest, putRequest } from "../../shared/api/axiosHandler";
import { toast } from "react-toastify";
import { BASE_URL } from "../../shared/utils/constants";

export const forgotPassword = async (email) => {
  try {
    return await postRequest('/public/api/auth/forgot-password', { email });
  } catch (error) {
    throw error;
  }
}

export const verifyOtp = async (email, otp) => {
  try {
    return await postRequest('/public/api/auth/verify-otp', { email, otp });
  } catch (error) {
    throw error;
  }
};

export const resetPassword = async (token, newPassword) => {
  try {
    return await putRequest('/public/api/auth/customer/reset-password', { token, newPassword });
  } catch (error) {
    throw error;
  }
};

export const generateOTPRegister = async (email) => {
  try {
    return await postRequest('/auth/customer/generate-otp', { email });
  } catch (error) {
    throw error;
  }
};

export const loginUser = async (email, password) => {
    try {
      const response = await postRequest("/auth/customer/login", { email, password }, true);
      toast.success("Login successful.");
      return response; // Returns success response (token, user data, etc.)
    } catch (error) {
      throw error; // Throw error so the UI can handle it
    }
  };

export const logoutUser = async () => {
    
    try {
      localStorage.removeItem("accessToken");
      await postRequest("/auth/customer/logout", {}, true);
    } catch (error) {
      throw error;
    }
  };

export const checkLoginStatus = async () => {
    try {
      const response = await getRequest("/auth/customer/check-login", {}, true);
      return response; // User data (if logged in)
    } catch (error) {
      return null; // Return null if not logged in
    }
  };

export const logoutUserDirect = async () => {
    
  try {
    localStorage.removeItem("accessToken");
    await axios.post(`${BASE_URL}/auth/customer/logout`, {}, { withCredentials: true });
  } catch (error) {
  }
};

export const registerUser = async (userRequestDTO) => {
  try {
    const response = await postRequest("/auth/customer/register", userRequestDTO, true);
    toast.success("Registration successful.");
    return response; // Returns success response (token, user data, etc.)
  } catch (error) {
    const errorMessage = error.response?.data || 'Registration failed. Please try again.';
    toast.error(errorMessage);
    throw error; // Throw error so the UI can handle it
  }
};

export const sendAuthUserOTP = async () => {
  try {
    return await postRequest('/api/v1/customer/otp-notification', {}, true);
  } catch (error) {
    throw error;
  }
}

export const authVerifyOtp = async (otp) => {
  try {
    return await postRequest('/api/v1/customer/verify-otp', {otp}, true);
  } catch (error) {
    throw error;
  }
}

export const authChangePassword = async (token, newPassword) => {
  try {
    return await putRequest('/api/v1/customer/change-password', { token, newPassword }, true);
  } catch (error) {
    throw error;
  }
}
